import { IStadiumAdvisoryProperties } from '@autopylot-internal/tiles-client';
import { SecondaryWarningAdvisory } from '../SecondaryAdvisory.tsx';
import { ICompositeAdvisoryProperties } from './ICompositeAdvisoryProperties.ts';
import { AdvisoryLink } from './AdvisoryLink.tsx';

export const StadiumsAdvisory = (props: ICompositeAdvisoryProperties<IStadiumAdvisoryProperties>) => {
    const distinctNames = Array.from(new Set(props.advisories.map(a => a.NAME)));
    return (
        <SecondaryWarningAdvisory header="Stadium Notice" advisoryType={props.advisoryType}>
            <>
                <p>
                    Flight operations within <strong>3&nbsp;NM</strong> of an FAA-designated stadium are restricted
                    from <strong>1&nbsp;hour before</strong> the planned start time until <strong>1&nbsp;hour after</strong> the end of any qualifying event.
                    Check the stadium schedule{distinctNames.length > 1 ? 's' : ''} (<strong>{distinctNames.join(', ')}</strong>) prior to any flight operations.
                </p>
                <p>
                    <AdvisoryLink
                        text="Drones Are Prohibited In and Around Stadiums"
                        url="https://www.faa.gov/uas/resources/community_engagement/no_drone_zone/stadiums"
                    />
                </p>
            </>
        </SecondaryWarningAdvisory>
    );
};
